import { FC } from "react"
import If from "../../../if"
import { BBColumnDef, Connector } from "../../../../../types"
import NameCell from "./cells/name"
import DirectionCell from "./cells/direction"
import DataTypeCell from "./cells/data-type"
import ActionsCell from "./cells/actions"
import Table from "../../../table"

interface Props {
  data: Connector[]
  isFetching: boolean
  onSelect: (val: string) => void
}

const ConnectorsTable: FC<Props> = ({ data, isFetching, onSelect }) => {
  const columns: BBColumnDef<Connector>[] = [
    {
      id: "name",
      header: "Name",
      accessorFn: row => row.name,
      footer: props => props.column.id,
      cell: props => <NameCell info={props.row.original} onSelect={onSelect} />
    },
    {
      id: "direction",
      header: "Direction",
      accessorFn: row => row.direction,
      footer: props => props.column.id,
      cell: props => <DirectionCell info={props.row.original} />
    },
    {
      id: "data_type",
      header: "Data Type",
      accessorFn: row => row.data_type,
      footer: props => props.column.id,
      cell: props => <DataTypeCell info={props.row.original} />
    },
    {
      id: "actions",
      header: "Actions",
      accessorFn: row => row.id,
      footer: props => props.column.id,
      cell: props => (
        <ActionsCell info={props.row.original} onSelect={onSelect} />
      )
    }
  ]

  return (
    <div>
      <If
        condition={!data?.length && !isFetching}
        then={
          <div className="text-center py-8 text-gray-500">
            No connectors found. Click "Add New" to create your first connector.
          </div>
        }
        else={
          <Table
            isLoading={isFetching}
            data={data}
            columns={columns}
            viewType="table"
            autoResetPageIndex={false}
            shrinkFilterSort
            noHeader
            searchBarVisible={false}
            defaultSortBy="created"
            defaultSortDir="desc"
          />
        }
      />
    </div>
  )
}

export default ConnectorsTable
